/**
 * Gallery-Section bootstrap.
 *
 * - `grid`    — pure CSS Grid, no JS.
 * - `masonry` — pure CSS multi-column (column-count), no JS.
 * - `slider`  — Slick carousel with responsive slide counts.
 *
 * Lightbox: explicit `featherlightGallery()` per `.gallery-wrap` so each
 * section forms its own group (prev/next don't bleed across sections).
 * The `<a>` markup intentionally does NOT carry `data-featherlight-*`
 * attributes — that would trigger Featherlight's auto-bind which conflicts
 * with the per-wrapper grouping below.
 */

import 'slick-carousel';

const initSlider = ($wrap) => {
	const slidesDesktop = parseInt($wrap.data('slides-desktop'), 10) || 3;
	const slidesTablet  = parseInt($wrap.data('slides-tablet'),  10) || 2;
	const autoplay      = $wrap.data('slider-autoplay') === 1
	                      || $wrap.data('slider-autoplay') === '1';

	$wrap.slick({
		slidesToShow:   slidesDesktop,
		slidesToScroll: 1,
		dots:           true,
		arrows:         true,
		autoplay:       autoplay,
		autoplaySpeed:  4500,
		pauseOnHover:   true,
		infinite:       true,
		draggable:      true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow:   slidesTablet,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow:   1,
					slidesToScroll: 1,
				},
			},
		],
	});
};

const initLightbox = ($wrap) => {
	const $links = $wrap.find('.gallery-link');

	if ( $links.length === 0 ) {
		return;
	}

	// Featherlight + Featherlight-Gallery are bundled globally via theme.js.
	// Guard against the rare case where the bundle order changes.
	if ( typeof jQuery.fn.featherlightGallery !== 'function' ) {
		// eslint-disable-next-line no-console
		console.warn('[gallery-section] featherlightGallery plugin not found.');
		return;
	}

	$links.featherlightGallery({
		previousIcon:    '&#8249;',
		nextIcon:        '&#8250;',
		galleryFadeIn:   200,
		galleryFadeOut:  300,
		openSpeed:       250,
		closeSpeed:      200,
		closeOnClick:    'background',
		variant:         'gallery-lightbox',
		type:            'image',
	});

	// Safety net: even if Featherlight binding fails for some reason, never
	// let the browser navigate to the raw image URL — that's the "opens in
	// new tab" symptom.
	$links.on('click.galleryFallback', function (e) {
		// If Featherlight has already opened (preventDefault'd), this no-ops.
		if ( e.isDefaultPrevented() ) {
			return;
		}
		e.preventDefault();
	});
};

export const gallerySection = () => {
	jQuery(function ($) {
		const $grids = $('.gallery-wrap');

		if ( $grids.length === 0 ) {
			return;
		}

		$grids.each(function () {
			const $wrap  = $(this);
			const layout = $wrap.data('gallery-layout');

			if ( layout === 'slider' ) {
				initSlider($wrap);
			}

			if ( $wrap.data('lightbox') === 1 || $wrap.data('lightbox') === '1' ) {
				initLightbox($wrap);
			}
		});
	});
};
